const dismissKyb = JSON.parse(sessionStorage.getItem("dismissKyb")) || false;
export const getContentWrapperClass = (props) => {
  const { accountReducer: { kybStatus: { kyb_status = 0 } = {} } = {} } = props;
  return (!dismissKyb && !props.isFirstRewardSent) ||
    (props.accountReducer?.mfaData?.res?.length &&
      props.accountReducer?.mfaData?.res?.[0]?.skip_mfa == 1) ||
    kyb_status === 6 ||
    kyb_status === 7
    ? "contentWrapper mt-40"
    : "contentWrapper";
};

export const getContentWrapperHeight = (props) => {
  const { accountReducer: { kybStatus: { kyb_status = 0 } = {} } = {} } = props;
  return (!dismissKyb && !props.isFirstRewardSent) ||
    (props.accountReducer?.mfaData?.res?.length &&
      props.accountReducer?.mfaData?.res?.[0]?.skip_mfa == 1) ||
    kyb_status === 6 ||
    kyb_status === 7
    ? "112px"
    : "72px";
};
